import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import "./style.less";
import { Subtitle, Title, SubSubtitle } from "src/Common/Theme/Typography";
import triangle from "src/Components/HomePage/Components/01-Banner/Assets/Icons/BannerLeftVector.svg";
import { isDesktop } from "isDesktop";
import { REGIONS } from "src/Services/RegionGetter/Constants";
import {
  bannerHeaderEng,
  bannerHeaderMy,
  bannerHeaderVn,
  bannerHeaderVnEng,
  bannerSubtitleEng,
  bannerSubtitleMy,
  bannerSubtitleVn,
  bannerSubtitleVnEng,
  bannerDownloadEng,
  bannerDownloadMy,
  bannerDownloadVn,
  bannerDownloadVnEng,
  bannerAppStoresEng,
  bannerAppStoresMy,
  bannerAppStoresVn,
} from "../../Constants/Constants";
import { getAppStoreLogos } from "src/Common/Services";

export const HomePageBanner = () => {
  // reducer
  const regionLanguage = useSelector((state) => state.RegionLanguageReducer);
  const { region, language } = regionLanguage;

  // state
  const [BannerHeader, setBannerHeader] = useState("");
  const [BannerSubtitle, setBannerSubtitle] = useState("");
  const [BannerDownload, setBannerDownload] = useState("");
  const BannerAppStores = getAppStoreLogos(bannerAppStoresVn);
  const capitalizedRegion = region?.toUpperCase();

  // effect
  useEffect(() => {
    switch (true) {
      case language === REGIONS.malaysia:
        setBannerHeader(bannerHeaderMy);
        setBannerSubtitle(bannerSubtitleMy);
        setBannerDownload(bannerDownloadMy);

        break;
      case region === REGIONS.malaysia && language === "en":
        setBannerHeader(bannerHeaderEng);
        setBannerSubtitle(bannerSubtitleEng);
        setBannerDownload(bannerDownloadEng);

        break;
      case region === REGIONS.vietnam && language === "vn":
        setBannerHeader(bannerHeaderVn);
        setBannerSubtitle(bannerSubtitleVn);
        setBannerDownload(bannerDownloadVn);

        break;
      case region === REGIONS.vietnam && language === "en":
        setBannerHeader(bannerHeaderVnEng);
        setBannerSubtitle(bannerSubtitleVnEng);
        setBannerDownload(bannerDownloadVnEng);

        break;
      default:
    }
  }, [language, region]);

  return (
    <>
      {isDesktop() ? (
        <div className="HomePageBanner">
          <div className="HomePageBanner__container">
            <img
              className="HomePageBanner__vectorArea"
              src={triangle}
              alt="left Triangle"
            />
            <div
              className={`HomePageBanner__Banner__${capitalizedRegion}`}
              alt="Banner Image"
            />
            <div className="HomePageBanner__homeMainTitle">
              <div className="HomePageBanner__mainWrapper">
                <div className="HomePageBanner__title">
                  <Title shopee bold className="HomePageBanner__BannerTitle">
                    {BannerHeader}
                  </Title>
                  <br />
                </div>
                <div className="HomePageBanner__subTitle">
                  <Subtitle>{BannerSubtitle}</Subtitle>
                </div>
                <div className="HomePageBanner__subTitleSecond">
                  <SubSubtitle className="HomePageBanner__textStyle">
                    {BannerDownload}
                  </SubSubtitle>
                </div>
                {BannerAppStores.map((icon, index) => (
                  <a href={icon.link} key={index}>
                    <img
                      className="HomePageBanner__logoStyle"
                      src={icon.img}
                      alt={icon.description}
                      width={icon.width}
                      key={index}
                    />
                  </a>
                ))}
              </div>
            </div>
            <div id="about" />
          </div>
        </div>
      ) : (
        <div className="HomePageBannerMobile">
          <div className="HomePageBannerMobile__headerImg">
            <div
              className={`HomePageBannerMobile__topImg__${capitalizedRegion}`}
              alt="Banner Image"
            />
          </div>
          <div className="HomePageBannerMobile__Wrapper">
            <Title
              className="HomePageBannerMobile__textStyleMobile"
              bold
              shopee
            >
              {BannerHeader}
            </Title>
            <div className="HomePageBannerMobile__subTitleMobile">
              <Subtitle>{BannerSubtitle}</Subtitle>
            </div>
            <div className="HomePageBannerMobile__TextBox">
              <SubSubtitle
                medium
                className="HomePageBannerMobile__downloadText"
              >
                {BannerDownload}
              </SubSubtitle>
            </div>
            <div className="HomePageBannerMobile__downloadTextBox">
              {BannerAppStores.map((icon, index) => (
                <a href={icon.link} key={index}>
                  <img
                    className="HomePageBannerMobile__logoStyle"
                    src={icon.img}
                    alt={icon.description}
                    key={index}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
